export class CreditCardData {
    name?: string;
    number?: string;
    cvc?: string;
    expiry?: string;
    phone?: string;
    isDefault: boolean;

    constructor() {
        this.name = "";
        this.number = "";
        this.cvc = "";
        this.expiry = "";
        this.phone = "";
        this.isDefault = false;
    }
}
